import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { APP_AUTH_CONST } from 'constant'
import { Decrypt } from '../hooks/EncryptDecrypt';

const GetAuthUser = () => {
    try {
        const data = localStorage.getItem(APP_AUTH_CONST) || ""
        const user = Decrypt(data)
        if (user) {
            return JSON.parse(user)
        }
        return null
    } catch (e) {
        ResetAuthUser()
        return null
    }
}

const ResetAuthUser = () => {
    localStorage.removeItem(APP_AUTH_CONST);
}

const initialState = { user: GetAuthUser() }

const AuthSlice = createSlice({
    name: 'Auth',
    initialState,
    reducers: {
        SET_AUTH(state, action: PayloadAction<any>) {
            state.user = action.payload
        },
        RESET_AUTH(state) {
            ResetAuthUser()
            state.user = null
        }
    },
})



export const { SET_AUTH, RESET_AUTH } = AuthSlice.actions
export default AuthSlice.reducer